import script from "./MoveToFolderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoveToFolderModal.vue?vue&type=script&setup=true&lang=ts"

import "./MoveToFolderModal.vue?vue&type=style&index=0&id=6dd0eac2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dd0eac2"]])

export default __exports__